import { Select, Table } from "antd";
import SearchAndFilter from "../SearchAndFilter/index";
import "./index.scss";
import { pageSizeOptionsPaging } from "utils/constant";
import { useSelector } from "react-redux";

const DynamicTable = (props: any) => {
  // Destructuring props
  const { Column } = Table;
  const {
    itemDataSource,
    performSearchHandler,
    searchValue,
    totalRecords,
    currentPage,
    PageSize,
    modifyPageSize,
    paginationChangeHandler,
    searchFieldsSelectHandler,
    resetButtonHandler,
    searchFields,
    itemModelOptions,
    handleModelChange,
    roleName,
  } = props;

  const itemLoading = useSelector((state: any) => state?.qbdItems?.isLoading);

  // Render description with dash if empty
  const renderDescription = (text: string) => {
    return text ? text : "-";
  };

  return (
    <div className={"dynamic-table"}>
      <SearchAndFilter
        performSearchHandler={performSearchHandler}
        searchValue={searchValue}
        PageSize={PageSize}
        searchFieldsSelectHandler={searchFieldsSelectHandler}
        resetButtonHandler={resetButtonHandler}
        searchFields={searchFields}
        menuName="ItemInventory"
        options={[
          { label: "Description", value: "salesDescription" },
          { label: "Name", value: "name" },
        ]}
      />

      <Table
        dataSource={itemDataSource}
        scroll={{ y: "calc(100vh - 350px)", x: "63vh" }}
        pagination={{
          total: totalRecords,
          current: currentPage,
          onChange: paginationChangeHandler,
          pageSize: PageSize,
          pageSizeOptions: pageSizeOptionsPaging,
          showSizeChanger: true,
          onShowSizeChange: modifyPageSize,
        }}
        loading={itemLoading}
        className="table-global"
      >
        <Column title="Name" dataIndex="name" key="name" className="bg-white" />
        <Column
          title="Description"
          dataIndex="salesDescription"
          key="salesDescription"
          className="bg-white"
          render={renderDescription}
        />
        <Column
          title="Quantity On Site"
          dataIndex="quantityOnHandOnsite"
          key="quantityOnHandOnsite"
          className="bg-white"
        />
        <Column
          title="Quantity On FTZ"
          dataIndex="quantityOnHandFTZ"
          key="quantityOnHandFTZ"
          className="bg-white"
        />

        {(roleName === "Admin 3nStar" || roleName === "3nStar Employee 1") && (
          <Column
            title="Item Model"
            key="itemModel"
            className="bg-white"
            render={(text, record) => (
              <Select
                options={itemModelOptions.map(({ id, modelName }) => ({
                  label: modelName,
                  value: id,
                }))}
                placeholder="Select Model"
                onChange={(value) => handleModelChange(value, record)}
                showSearch
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option.label as string)
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                value={record.modelId}
                style={{ width: "100%" }}
              />
            )}
          />
        )}
      </Table>
    </div>
  );
};

export default DynamicTable;
